import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  siteurl :any;
  constructor() { }

  ngOnInit(): void {
    this.siteurl = "www.unisa.it"
    document.getElementById('nb-global-spinner').style.display = 'none';
  }

}
